const RATE_PATTERN = /^((LRA|NLRA|GOVT)_S[1-5]_RT[1-3]_(SGL|DBL)|DYNAMIC_PRICING|DYNAMIC_PCT_Discount)$/;

const HotelRfpRatePattern = {
  testRates (text) {
    return RATE_PATTERN.test(text);
  }
};

export default HotelRfpRatePattern;
